import Work1 from "../../assets/work1.png";
import Work2 from "../../assets/work2.png";
import Work3 from "../../assets/work3.png";
import Work4 from "../../assets/work4.jpg";
import Work5 from "../../assets/work5.jpg";
export const projectsData = [
	{
		id: 1,
		image: Work1,
		title: "University website",
		category: "web",
	},
	{
		id: 2,
		image: Work2,
		title: "Portfolio website",
		category: "web",
	},
	{
		id: 3,
		image: Work3,
		title: "Testy Benna",
		category: "web",
	},
	{
		id: 4,
		image: Work4,
		title: "",
		category: "app",
	},
	{
		id: 5,
		image: Work5,
		title: "Web design",
		category: "web",
	},
];
export const projectsNav = [
	{ name: "all" },
	{ name: "web" },
	{ name: "app" },
	{ name: "design" },
];
